module.exports = __webpack_public_path__ + "img/mail-sent.72ffd05a.svg";